module.exports = __webpack_public_path__ + "assets/aba2c36f845559387b7e11db619be2ac.png";